import LazyLoad from "vanilla-lazyload"

const lazyInstance = new LazyLoad({elements_selector: ".lazy", callback_loaded: el => el.parentNode.classList.remove('is-loading')})

export const updateLazyLoad = () => lazyInstance.update()